import {useEffect} from 'react';
import type {Editor} from 'grapesjs';
import type {FormMakerFormMode} from '@FormMakerReact/form-maker.types';
import {selectFormBackgroundForTab} from '@FormMakerReact/lib/form-maker-library';

export function useFormBackdropReselect(editor: Editor | null, activeMode: FormMakerFormMode): void {
  useEffect(() => {
    if (!editor) {
      return undefined;
    }
    const handler = (): void => {
      scheduleFormBackgroundReselect(editor, activeMode);
    };
    editor.on('component:deselected', handler);
    return (): void => {
      editor.off('component:deselected', handler);
    };
  }, [editor, activeMode]);
}

function scheduleFormBackgroundReselect(editor: Editor, activeMode: FormMakerFormMode): void {
  queueMicrotask((): void => {
    if (editor.getSelected()) {
      return;
    }
    selectFormBackgroundForTab(editor, activeMode);
  });
}
